/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneProcedurePreviewRoute extends Route {
  templateName = 'apps/app/automation/fin-ai-agent/procedures/procedure/preview';

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneProcedurePreviewRoute, {
  overrideRenderTemplate: false,
});
